import { render, staticRenderFns } from "./form-item-customer.vue?vue&type=template&id=29ccbf6a&"
import script from "./form-item-customer.vue?vue&type=script&lang=js&"
export * from "./form-item-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports